import { useFormik } from 'formik'
import Modal from 'global/Modal/Modal'
import { gatewayPayment } from 'global/payment/gatewayPayment'
import SimpleButton from 'global/SimpleButton/SimpleButton'

function PriceNotification({ open, setOpen, onClick, payment }) {
  const { handleSubmit, isSubmitting } = useFormik({
    enableReinitialize: true,
    // validationSchema: AssignmentValidation,
    initialValues: {},
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        await gatewayPayment(
          payment,
          '/consignment-api/payments/payment-links/consignments/cod-post-payment/no-sms'
        )
        setSubmitting(false)
      } catch {
        setSubmitting(false)
      }
    },
  })

  return (
    <Modal visible={open} setVisible={setOpen} title='پرداخت از طریق درگاه'>
      <form onSubmit={handleSubmit}>
        <div className='text-base flex justify-between w-96'>
          <span>مبلغ پرداختی: </span>
          <span className='font-semibold'>
            {payment?.debt?.toLocaleString()}
            ریال
          </span>
        </div>

        <div className='btnForm'>
          <SimpleButton
            handelClick={() => setOpen({ ...open, bankDelivery: false })}
            text='لغو'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            // handelClick={() => onClick({ pay: payment.amount })}
            text=' پرداخت'
            className='full-tomato-btn'
            loading={isSubmitting}
          />
        </div>
      </form>
    </Modal>
  )
}

export default PriceNotification
